export enum RightDrawerTypeEnum {
  help = 'help',
  settings = 'settings',
  notifications = 'notifications'
}

export const RightDrawerTitles = {
  [RightDrawerTypeEnum.help]: 'Help',
  [RightDrawerTypeEnum.settings]: 'Settings',
  [RightDrawerTypeEnum.notifications]: 'Notifications'
};
